function PageScroll(enable) {
  if (enable) {
    document.body.classList.remove('stop-scrolling');
  } else {
    document.body.classList.add('stop-scrolling');
  }
}

function setMenuPosition(menu) {
  const header = document.querySelector('.site-header');
  if (header) {
    const height = header.offsetHeight;

    menu.style.height = `${window.innerHeight - height}px`;
    menu.style.top = `${height}px`;
  } else {
    menu.style.height = `${window.innerHeight}px`;
  }
}

function handleBars(trigger, menu, fullheight) {
  const TRANSITION = 400;

  const show = () => {
    if (fullheight) PageScroll(false);

    trigger.classList.add('close');

    if (fullheight) {
      setMenuPosition(menu);

      menu.style.display = 'flex';
    }

    setTimeout(() => menu.classList.add('visible'));
  };

  const hide = () => {
    trigger.classList.remove('close');
    menu.classList.remove('visible');

    setTimeout(() => {
      if (fullheight) menu.style.display = 'none';

      PageScroll(true);
    }, TRANSITION);
  };

  window.addEventListener('click', () => hide());

  trigger.addEventListener('click', (event) => {
    event.stopPropagation();

    const isVisible = trigger.classList.contains('close') || menu.classList.contains('visible');

    // eslint-disable-next-line no-unused-expressions
    !isVisible ? show() : hide();
  });

  if (!fullheight) {
    menu.addEventListener('click', (event) => {
      event.stopPropagation();

      show();
    });
  } else {
    const sub = menu.querySelector('.site-mobile-menu');
    if (sub) {
      menu.addEventListener('click', (event) => event.preventDefault());

      sub.addEventListener('click', (event) => {
        event.stopPropagation();

        show();
      });
    }
  }
}

export default class HeaderMenu {
  constructor(trigger, menu, fullheight = false) {
    this.selector = { trigger, menu };
    this.fullheight = fullheight;
  }

  init() {
    this.trigger = document.querySelector(this.selector.trigger);
    this.menu = document.querySelector(this.selector.menu);
    if (!this.trigger || !this.menu) return;

    if (this.fullheight) {
      setMenuPosition(this.menu);

      window.addEventListener('resize', () => setMenuPosition(this.menu));
    }

    handleBars(this.trigger, this.menu, this.fullheight);
  }
}
